import { render } from "./AdminMasivo.vue?vue&type=template&id=20d4517f&scoped=true"
import script from "./AdminMasivo.vue?vue&type=script&lang=js"
export * from "./AdminMasivo.vue?vue&type=script&lang=js"

import "./AdminMasivo.vue?vue&type=style&index=0&id=20d4517f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d4517f"]])

export default __exports__